import { regisConstants, uriConstants } from '../../constants'
import { defaultService } from '../../services'
import { alertActions } from '../'
import { errorMessages } from '../../messages'
import history from '../../../route/history'
import axios from 'axios'
import { data } from 'jquery'

export const regisActions = {
  registManager,
  registSimpleManager,
  registUser,
  // checkGroupId,
  checkMemberId,
  checkResetGroupId,
  checkResetId,
  checkResetRgsNo,
  checkedRegistNo,
  registComplete,
  getInviteInfo,
  setJoinFlag,
  checkedJoinFlag,
  getUthInfo,
  checkedRegNo,
  onCrtfctfInfo,
  delCrtfctfInfo,
  checkMobile,
  duplBizNo,
  checkCrtfctInfo,
  checkDuplBizNoYN,
  setDuplBizNo,
}

/**
 * 관리자 회원가입
 */
function registManager(params) {
  return (dispatch) => {
    dispatch(apiAction(regisConstants.REGISTER_MANAGER_REQUEST))

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)

    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.REGIS_MANAGER,
        params: paramStr,
      })
      .then(
        (response) => {
          dispatch(apiAction(regisConstants.REGISTER_MANAGER_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(regisConstants.REGISTER_MANAGER_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

/**
 * 간편회원가입 - 연계(모바일)
 * @param params
 */
function registSimpleManager(params) {
  return (dispatch) => {
    dispatch(apiAction(regisConstants.REGISTER_SIMPLE_MANAGER_REQUEST))

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)

    defaultService
        .handleService({
          method: 'post',
          endPoint: uriConstants.API_URI + uriConstants.REGIS_SIMPLE_MANABER,
          params: paramStr,
        })
        .then(
            (response) => {
              dispatch(apiAction(regisConstants.REGISTER_SIMPLE_MANAGER_SUCCESS, response))
            },
            (error) => {
              dispatch(apiAction(regisConstants.REGISTER_SIMPLE_MANAGER_FAILURE, error))
              dispatch(apiError(error))
            },
        )
  }
}

/**
 * 초대정보 조회
 */
function getInviteInfo(inviteId) {
  return (dispatch) => {
    dispatch(apiAction(regisConstants.GET_INVITE_REQUEST))

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.GET_INVITE_INFO + '/' + inviteId,
      })
      .then(
        (response) => {
          dispatch(apiAction(regisConstants.GET_INVITE_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(regisConstants.GET_INVITE_FAILURE, error))
          dispatch(
            alertActions.success({
              title: '오류',
              message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
              params: {
                type: 'success',
                callback: () => {
                  window.location.replace('/login')
                },
              },
            }),
          )
        },
      )
  }
}

/**
 * 회원가입 분류
 */
function setJoinFlag(value) {
  switch (value) {
    case 'user':
      return { type: regisConstants.SET_JOIN_FLAG_USER }
    case 'corp':
      return { type: regisConstants.SET_JOIN_FLAG_CORP }
    case 'link':
      return { type: regisConstants.SET_JOIN_FLAG_LINK_CORP}
    case 'uth':
      return { type: regisConstants.SET_JOIN_FLAG_UTH }
  }
}

function checkedJoinFlag() {
  return {
    type: regisConstants.CHECKED_JOIN_FLAG,
  }
}

/**
 * 회원가입
 */
function registUser(params) {
  return (dispatch) => {
    dispatch(apiAction(regisConstants.REGISTER_USER_REQUEST))

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)

    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.REGIS_USER,
        params: paramStr,
      })
      .then(
        (response) => {
          dispatch(apiAction(regisConstants.REGISTER_USER_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(regisConstants.REGISTER_USER_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

/**
 * 사업체 이이디 중복체크
 */
// function checkGroupId(groupCd) {
// 	return dispatch => {
// 		dispatch(apiAction(regisConstants.CHECK_GROUP_REQUEST))

// 		defaultService.handleService({
// 			method: 'get',
// 			endPoint: uriConstants.API_URI + uriConstants.CHECK_GROUP + "/" + groupCd,
// 		})
// 			.then(
// 				response => {
// 					dispatch(apiAction(regisConstants.CHECK_GROUP_SUCCESS, response))
// 				},
// 				error => {
// 					dispatch(apiAction(regisConstants.CHECK_GROUP_FAILURE, error))
// 					dispatch(apiError(error))
// 				}
// 			)
// 	}
// }

/**
 * 이용자 이이디 중복체크
 */
function checkMemberId(userId) {
  return (dispatch) => {
    dispatch(apiAction(regisConstants.CHECK_ID_REQUEST))

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.CHECK_ID + '/' + userId,
      })
      .then(
        (response) => {
          dispatch(apiAction(regisConstants.CHECK_ID_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(regisConstants.CHECK_ID_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

/**
 * 아이디 중복확인 후 수정했을 경우 호출
 */
function checkResetGroupId() {
  return {
    type: regisConstants.CHECK_GROUP_RESET,
  }
}

function checkResetId() {
  return {
    type: regisConstants.CHECK_ID_RESET,
  }
}

function checkResetRgsNo() {
  return {
    type: regisConstants.CHECK_RGSNO_RESET,
  }
}

function registComplete() {
  return {
    type: regisConstants.REGISTER_COMPLETE,
  }
}

/**
 * 사업자등록번호
 */
function checkedRegistNo(checked) {
  console.log(checked)
  return {
    type: regisConstants.CHECKED_REGIST_NO,
    checkedRegistNo: checked,
  }
}
function checkDuplBizNoYN(checked){
  if(!checked) checked = false;
  return {
    type : regisConstants.DUPLE_BIZNO_SUCCESS,
    response :{data:{payload:checked}},
  }

}
/**
 * uTradeHub 사용자 정보 조회
 */
function getUthInfo(uthId, uthPasswd) {
  const queryString = require('query-string')
  let paramStr = queryString.stringify({ uthId, uthPasswd })
  // paramStr.length > 0 && ( paramStr = "?" + paramStr )

  return (dispatch) => {
    dispatch(apiAction(regisConstants.UTH_INFO_REQUEST))

    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.GET_UTH_INFO, //+ paramStr,
        params: paramStr,
      })
      .then(
        (response) => {
          if (response.data.payload?.companyNm === null) {
            dispatch(infoFail(response))
            return
          } else {
            //	alert(JSON.stringify(response.data.payload));
            dispatch(apiAction(regisConstants.UTH_INFO_SUCCESS, response))
            history.replace({ pathname: '/regis/' })
          }
        },
        (error) => {
          dispatch(apiAction(regisConstants.UTH_INFO_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

function getLinkInfo(seq) {
  // const queryString = require('query-string')
  // //let paramStr = queryString.stringify({ name, passwd })
  // // paramStr.length > 0 && ( paramStr = "?" + paramStr )
  //
  // return (dispatch) => {
  //   dispatch(apiAction(regisConstants.LINk_INFO_REQUEST))
  //
  //   defaultService
  //       .handleService({
  //         method: 'get',
  //         endPoint: uriConstants.API_URI + uriConstants.GET_LINK_INFO + paramStr,
  //       })
  //       .then(
  //           (response) => {
  //               alert(JSON.stringify(response.data.payload));
  //               dispatch(apiAction(regisConstants.LINk_INFO_SUCCESS, response))
  //               history.replace({ pathname: '/regis/simpleCompany' })
  //           },
  //           (error) => {
  //             dispatch(apiAction(regisConstants.LINk_INFO_FAILURE, error))
  //             dispatch(apiError(error))
  //           },
  //       )
  // }
}
function infoFail(response) {
  return alertActions.info({
    title: null,
    message: response.data?.payload?.length > 0 ? response.data?.payload : errorMessages.uthInfoFail,
  })
}

/**
 * API 액션 함수
 */
function apiAction(type, response = null) {
  let resultObj = { type }
  response && (resultObj.response = response)
  return resultObj
}

/**
 * API 통신 에러 문구 공통처리
 */
function apiError(error) {
  return alertActions.info({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
  })
}

/**
 *  주민등록번호
 */
function checkedRegNo(checked) {
  return {
    type: regisConstants.CHECKED_REGIST_NO,
    checkedRegNo: checked,
  }
}

/* function registUser(params) {
  return (dispatch) => {
    dispatch(apiAction(regisConstants.REGISTER_USER_REQUEST))

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)

    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.REGIS_USER,
        params: paramStr,
      })
      .then(
        (response) => {
          dispatch(apiAction(regisConstants.REGISTER_USER_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(regisConstants.REGISTER_USER_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
} */

/**
 * 인증서 정보 확인
 */
 function checkCrtfctInfo(userId) {
  return (dispatch) => {
    dispatch(apiAction(regisConstants.CHECK_CRTFCT_REQUEST))
    const queryString = require('query-string')
    let paramStr = queryString.stringify(userId)
console.log(paramStr)
    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.CHCEK_CRTFCT_INFO,
        params: paramStr,
      })
      .then(
        (response) => {
          dispatch(apiAction(regisConstants.CHECK_CRTFCT_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(regisConstants.CHECK_CRTFCT_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

/******
 인증서 정보 저장
 *****/
function onCrtfctfInfo(params, gbn) {
  return async (dispatch) => {
    dispatch(apiAction(regisConstants.ADD_CRTFCT_REQUEST))
    //console.log('--->', params)
    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)

    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.ADD_CRTFCT_INFO,
        params: paramStr + '&gbn=' + gbn,
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(apiAction(regisConstants.ADD_CRTFCT_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
  function success(response) {
    return alertActions.success({
      title: '확인',
      message: errorMessages.crtfctLoginState,
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.replace('/crtfct/mng')
        },
      },
    })
  }
}

/******
 인증서 정보 삭제
 *****/
function delCrtfctfInfo(params) {
  return async (dispatch) => {
    dispatch(apiAction(regisConstants.ADD_CRTFCT_REQUEST))
    //console.log('--->', params)
    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)

    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.DEL_CRTFCT_INFO,
        params: paramStr,
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(apiAction(regisConstants.ADD_CRTFCT_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
  function success(response) {
    return alertActions.success({
      title: '확인',
      message: errorMessages.crtfctLoginStateDel,
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.replace('/crtfct/mng')
        },
      },
    })
  }
}

/**
 * 권한(개인/법인), 휴대폰번호, 인증CI값 중복체크
 * @param {String} userSeCd
 * @param {String} mobileNo
 * @param {String} certCi
 * @returns boolean (중복일 경우 false)
 */
function checkMobile(userSeCd, mobileNo, certCi) {
  const queryString = require('query-string')
  // CI 가 URL(접속 로그·브라우저 기록)에 남지 않도록 POST 본문으로 보낸다.
  const paramStr = queryString.stringify({ userSeCd, mobileNo, certCi })

  return (dispatch) => {
    dispatch(apiAction(regisConstants.CHECK_MOBILE_REQUEST))

    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + uriConstants.CHECK_MOBILE,
        params: paramStr,
      })
      .then(
        (response) => {
          dispatch(apiAction(regisConstants.CHECK_MOBILE_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(regisConstants.CHECK_MOBILE_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

function duplBizNo(bizNo) {
  const queryString = require('query-string')
  let paramStr = queryString.stringify({ bizNo })
  paramStr.length > 0 && (paramStr = '?' + paramStr)

  return (dispatch) => {
    dispatch(apiAction(regisConstants.DUPLE_BIZNO_REQUEST))

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.DUPLE_BIZNO + paramStr,
      })
      .then(
        (response) => {
          console.log(response)
          dispatch(apiAction(regisConstants.DUPLE_BIZNO_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(regisConstants.DUPLE_BIZNO_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}

function setDuplBizNo(check){
  let response = {data:{payload:true}}
  return (dispatch)=>{
    if (check){
      dispatch(apiAction(regisConstants.DUPLE_BIZNO_SUCCESS, response))
    }else{
      dispatch(apiAction(regisConstants.DUPLE_BIZNO_FAILURE, {}))
    }
  }
}
